<template>
  <b-modal
    v-model="internalVisible"
    hide-header
    hide-footer
    centered
    size="sm"
    body-class="p-[24px] text-center"
  >
    <div class="flex flex-col items-center justify-center">
      <img
        src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png"
        alt="warning"
        class="w-[98px] h-[92px] mb-2"
        @error="$event.target.src='https://storage.googleapis.com/komerce/assets/svg/warning-circle.svg'"
      >
      <h4 class="text-[18px] font-bold text-black mb-[8px]">
        Apa Kamu Yakin?
      </h4>
      <p class="text-[14px] text-[#828282] mb-[24px]">
        Nomor <span class="font-semibold text-black">{{ targetNumber }}</span> akan dihapus secara permanen. Lanjutkan?
      </p>
      <div class="flex justify-center gap-[12px] w-full">
        <b-button
          variant="outline-secondary"
          class="flex-1 rounded-[8px] text-[14px] font-semibold"
          @click="internalVisible = false"
        >
          Batal
        </b-button>
        <b-button
          variant="primary"
          class="flex-1 rounded-[8px] text-[14px] font-semibold text-white border-none"
          @click="handleConfirm"
        >
          Hapus
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalDelete',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    targetNumber: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    internalVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm')
    },
  },
}
</script>
